import ParticlesBg from "particles-bg";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <ParticlesBg
          type="cobweb"
          bg={{ zIndex: 1, position: "absolute", top: 0 }}
          color="#5b8def"
          num={80}
        />
        <div className="overlay" style={{ position: "relative", zIndex: 2, width: "100%" }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-7 text-center intro-text" style={{ padding: "180px 0 120px" }}>
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                {props.data?.paragraph && (
                  <p>{props.data.paragraph}</p>
                )}
                <div className="hero-cta">
                  <a href="#services" className="btn btn-custom">
                    What I do
                  </a>
                  <a href="#contact" className="btn-hero-outline">
                    Get in touch
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hero-scroll">
          <span>scroll</span>
          <div className="hero-scroll-line"></div>
        </div>
      </div>
    </header>
  );
};
